import { zeroTooltipTemplate as template, Tooltip as FoundationTooltip } from '@genesislcap/foundation-zero';
import { customTooltipStyles as styles } from './zero-tooltip.styles';

export class Tooltip extends FoundationTooltip {
    constructor() {
        super();
        this.delay = 300;
    }
};
export const customTooltip = Tooltip.compose({baseName: 'tooltip',
    template,
    styles
});